import ebook from './EbookContent';

class AssetManifest {
  constructor() {
    this.manifest = [];
  }
  addItem(name, fname) {
    // Check if item already exists, and skip if it does
    if (this.manifest.some(item => item.id === name)) return;

    this.manifest.push({ id: name, src: fname });
  }

  removeItem(name) {
    this.manifest.filter(item => item.id === name);
  }

  getFName(name) {
    const ret = ebook.getAssetObjectByName(name);
    if (ret) {
      return ret.file;
    }
    console.error(`File not found: Could not find: ${name} + ${this}`);
    return null;
  }
}

const assetManifest = new AssetManifest();
export { assetManifest as default };
